// Inline cards the appointment book shares between the booking panel and the
// customers register.
//
// NetworkCard: HANDOFF §7 «لم تنجح المحاولة.» + «تحقّق من الاتصال ثم أعد
// المحاولة.» + «أعد المحاولة». The shared ErrorCard's body also says «ما
// حُرّر على هذا الجهاز محفوظ محلياً.», which is true only for invoices and
// receipt vouchers (decision 12) — appointments and customers never queue,
// so that clause is dropped here (spec O26; SHARED-REQUESTS asks ErrorCard
// for a `localSave={false}` switch). «العمل بلا اتصال» is absent for the same
// reason.

import { CloudOff, RefreshCw } from 'lucide-react';
import { Button, ERROR_COPY } from '@/components';

/** «تحقّق من الاتصال ثم أعد المحاولة.» — the first sentence of the shared copy. */
export const NETWORK_BODY_NO_LOCAL = `${ERROR_COPY.networkBody.split('. ')[0]}.`;

export function NetworkCard({ onRetry, compact }: { onRetry?: () => void; compact?: boolean }) {
  return (
    <section className="e-errcard" data-kind="network" data-compact={compact ? 'true' : undefined} role="alert">
      <span className="e-errcard-icon" aria-hidden="true">
        <CloudOff />
      </span>
      <h2 className="e-errcard-title">{ERROR_COPY.networkTitle}</h2>
      <p className="e-errcard-body">{NETWORK_BODY_NO_LOCAL}</p>
      {onRetry && (
        <div className="e-errcard-actions">
          <Button variant="teal-line" icon={RefreshCw} onClick={onRetry}>
            {ERROR_COPY.retry}
          </Button>
        </div>
      )}
    </section>
  );
}
